import React, { useState } from 'react';
import { ImagePlaceholder, PrimaryButton, SecondaryButton } from '../ui/Primitives.jsx';
import { fillTemplate } from '../../lib/helpers.js';

// Oferta "one-time" da 2ª tentativa de saída. Diferente da concorrência, o
// diálogo de confirmação deixa igualmente visível e clicável a opção de
// recusar ("Perder oferta") — nunca escondida atrás de um botão minúsculo
// ou de cor apagada.
export default function ExitOffer({ step, gender, onAccept, onDecline }) {
  const [confirming, setConfirming] = useState(false);
  const images = step.backgroundImages?.[gender] ?? [];

  return (
    <div className="phone-frame flex flex-col safe-top safe-bottom relative">
      <div className="relative h-40">
        <div className="grid grid-cols-3 h-full">
          {(images.length ? images : [null, null, null]).map((img, i) => (
            <ImagePlaceholder key={i} src={img} className="w-full h-full object-cover" label="" />
          ))}
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-bg/10 to-bg" />
      </div>

      <div className="px-5 -mt-4 relative flex-1 flex flex-col">
        <h1 className="font-display text-4xl font-extrabold mb-2">{step.discountBadge} 🎉</h1>
        <p className="text-amber-400 text-sm mb-4">⚠ {step.warning}</p>

        <div className="bg-cyan text-bg text-center text-xs font-bold py-1.5 -mx-5 mb-6 -rotate-1">
          {step.ribbonLabel}
        </div>

        <div className="bg-surface-2 rounded-xl2 p-5 mb-4">
          <p className="text-center text-xs font-semibold text-ink-muted mb-3">{step.planLabel}</p>
          <p className="text-center font-display text-xl font-bold mb-1">{step.plan.name}</p>
          <p className="text-center">
            <span className="line-through text-ink-muted text-sm mr-2">{step.plan.originalPriceLabel}</span>
            <span className="font-display text-2xl font-extrabold text-cyan">{step.plan.discountedPriceLabel}</span>
            <span className="text-ink-muted text-sm"> por mês</span>
          </p>
          <ul className="mt-4 flex flex-col gap-2">
            {step.benefits.map((b) => (
              <li key={b} className="flex items-center gap-2 text-sm">
                <span className="text-cyan">✓</span> {b}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex-1" />
        <div className="py-4">
          <p className="text-center text-sm text-ink mb-4">
            {fillTemplate(step.billingDisclosureTemplate, { precoTotal: step.plan.totalPriceLabel ?? 'R$ 0,00' })}
          </p>
          <PrimaryButton onClick={onAccept}>{step.cta}</PrimaryButton>
        </div>
      </div>

      {/* botão de fechar visível — abre a confirmação honesta, sem esconder "recusar" */}
      <button
        onClick={() => setConfirming(true)}
        aria-label="Fechar"
        className="absolute top-4 right-4 w-8 h-8 rounded-full bg-bg/60 backdrop-blur flex items-center justify-center"
      >
        ✕
      </button>

      {confirming && (
        <div className="absolute inset-0 bg-bg/85 backdrop-blur-sm flex items-end">
          <div className="w-full bg-surface rounded-t-3xl p-6">
            <div className="text-3xl mb-3">⚠️</div>
            <h3 className="font-display text-xl font-bold mb-2">{step.confirmClose.title}</h3>
            <p className="text-ink-muted text-sm mb-6">{step.confirmClose.subtitle}</p>
            <div className="grid grid-cols-2 gap-3">
              <SecondaryButton onClick={onDecline}>{step.confirmClose.confirmLabel}</SecondaryButton>
              <PrimaryButton onClick={onAccept}>{step.confirmClose.acceptLabel}</PrimaryButton>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
